<template lang="pug">
base-container
  el-form(ref="elForm", :model="formData", size="medium", label-width="120px")
    el-form-item(label="邀请海报背景", prop="posterURL", required)
      single-upload-cos(v-model="formData.posterURL", uploadTip="(建议尺寸:590*850)")
        template(slot="imgPreview")
          el-image.avatar(
            v-if="formData.posterURL",
            :fit="fit",
            :src="formData.posterURL"
          )
    el-form-item(size="large")
      el-button(type="primary", class="mr8" @click="submitForm") 提交
      el-button(@click="resetForm") 重置
</template>
<script>
/**
 * 内容管理-海报背景设置
 */
import SingleUploadCos from '@/components/upload/single-upload-cos'
import { getPoster, setPoster } from '@/api/content'
export default {
  name: 'Poster',
  components: {
    SingleUploadCos
  },
  props: [],
  data() {
    return {
      fit: 'container',
      formData: {
        posterURL: null
      }
    }
  },
  mounted() {
    //  获取默认背景图
    this.initPoster()
  },
  methods: {
    initPoster() {
      getPoster().then((res) => {
        const { posterURL } = res.data
        this.formData.posterURL = posterURL
      })
    },
    submitForm() {
      this.$refs['elForm'].validate((valid) => {
        if (!valid) return
        const { posterURL } = this.formData
        setPoster({ posterURL }).then(() => {
          this.$message({
            type: 'success',
            message: '海报更新成功'
          })
        })
        // TODO 提交表单
      })
    },
    resetForm() {
      this.$refs['elForm'].resetFields()
    }
  }
}
</script>
<style lang="scss">
.el-upload__tip {
  line-height: 1.2;
  margin-top: 48px;
}
.avatar {
  display: block;
  margin-bottom: 20px;
  width: 200px;
  height: 200px;
}

</style>
